import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { getCurrentDomain } from '../config/domains';
import { CMSPageContent, getCMSPage } from '../services/api';

const About: React.FC = () => {
  const domain = getCurrentDomain();
  const [content, setContent] = useState<CMSPageContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getCMSPage('about').then((res) => {
      if (res.error) setError(res.error);
      else if (res.data) setContent(res.data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error loading content: {error}</div>;

  const fields = content?.fields ?? {};
  const values = content?.blocks?.values ?? [];

  return (
    <div>
      <div className="page-header">
        {fields.headline && (
          <h1 className="page-title" style={{ color: domain.primaryColor }}>{fields.headline}</h1>
        )}
      </div>

      <div className="page-content">
        {fields.intro && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fields.intro) }} />}
        {fields.mission && <div style={{ fontStyle: 'italic' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fields.mission) }} />}

        {values.length > 0 && (
          <div style={{ marginTop: '2rem' }}>
            <h3 style={{ color: domain.primaryColor }}>Our Values</h3>
            <ul style={{ marginLeft: '1.5rem' }}>
              {values.map((block) => (
                <li key={block.id} style={{ marginBottom: '0.5rem' }}>
                  <strong>{block.fields.title}</strong>
                  {block.fields.body && <span> — <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.fields.body) }} /></span>}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default About;
